var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C4.68667 0 2 2.68667 2 6H0L2.59333 8.59333L2.64 8.68667L5.33333 6H3.33333C3.33333 3.42 5.42 1.33333 8 1.33333C10.58 1.33333 12.6667 3.42 12.6667 6C12.6667 8.58 10.58 10.6667 8 10.6667C6.71333 10.6667 5.54667 10.14 4.70667 9.29333L3.76 10.24C4.84667 11.3267 6.34 12 8 12C11.3133 12 14 9.31333 14 6C14 2.68667 11.3133 0 8 0ZM7.33333 3.33333V6.66667L10.1667 8.34667L10.68 7.49333L8.33333 6.1V3.33333H7.33333Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.ae2a9b6d5a889b968b4a52af8f448a87.svg";
export { ForwardRef as ReactComponent };